import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./lineChart.css";

const lineData = [
  { name: "Jan", value1: 52, value2: 62 },
  { name: "Feb", value1: 58, value2: 68 },
  { name: "Mar", value1: 62, value2: 72 },
  { name: "Apr", value1: 68, value2: 78 },
  { name: "May", value1: 64, value2: 74 },
  { name: "Jun", value1: 70, value2: 80 },
  { name: "Jul", value1: 67, value2: 77 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-area-tooltip">
        <p className="tooltip-month">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} className="tooltip-item" style={{ color: entry.stroke }}>
            <span className="tooltip-label">{entry.name === 'value1' ? 'Value 1' : 'Value 2'}:</span>
            <span className="tooltip-value">{entry.value}</span>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const LineChartComponent = () => {
  return (
    <div className="chart-box area-chart-box">
      <h3 className="chart-title">Trend Analysis</h3>
      <ResponsiveContainer width="100%" height={350}>
        <AreaChart 
          data={lineData}
          margin={{ top: 10, right: 20, left: 0, bottom: 5 }}
        >
          <defs>
            <linearGradient id="colorValue1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8B4513" stopOpacity={0.5}/>
              <stop offset="95%" stopColor="#8B4513" stopOpacity={0.15}/>
            </linearGradient>
            <linearGradient id="colorValue2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#ffc107" stopOpacity={0.6}/>
              <stop offset="95%" stopColor="#ffc107" stopOpacity={0.2}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" opacity={0.5} />
          <XAxis 
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#666', fontSize: 12, fontWeight: 500 }}
          />
          <YAxis 
            domain={[50, 80]}
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#666', fontSize: 12 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            verticalAlign="top"
            align="right"
            height={36}
            iconType="circle"
            wrapperStyle={{ paddingBottom: '10px' }}
            formatter={(value, entry) => (
              <span style={{ color: entry.color, fontWeight: 600, fontSize: '13px' }}>
                {value === 'value1' ? 'Value 1' : 'Value 2'}
              </span>
            )}
          />
          <Area
            type="monotone"
            dataKey="value1"
            stackId="1"
            stroke="#8B4513"
            strokeWidth={2}
            fill="url(#colorValue1)"
            name="value1"
          />
          <Area
            type="monotone"
            dataKey="value2"
            stackId="1"
            stroke="#e65100"
            strokeWidth={2}
            fill="url(#colorValue2)"
            name="value2"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComponent;

